export default "__VITE_ASSET__3be5dd37__"